import httpClient from '../../global/httpClient';
import * as apis from '../../constants/api';

export const getAllCourses = () => httpClient.get(apis.GET_ALL_COURSES);
